<ng-container>
  <div *ngIf="root" class="layout-menuitem-root-text">{{ item.label }}</div>
  <a
    (click)="itemClick($event)"
    (keydown.enter)="itemClick($event)"
    (mouseenter)="onMouseEnter()"
    *ngIf="!item.routerLink || item.items"
    [attr.href]="item.url"
    [attr.tabindex]="0"
    [attr.target]="item.target"
    [ngClass]="item.class"
    pRipple
  >
    <i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
    <span class="layout-menuitem-text">{{ item.label }}</span>
    <i
      *ngIf="item.items"
      class="pi pi-fw pi-chevron-down layout-submenu-toggler"
    ></i>
  </a>
  <a
    (click)="itemClick($event)"
    (mouseenter)="onMouseEnter()"
    *ngIf="item.routerLink && !item.items"
    [attr.tabindex]="0"
    [attr.target]="item.target"
    [ngClass]="item.class"
    [routerLinkActiveOptions]="{ exact: true }"
    [routerLink]="item.routerLink"
    pRipple
    routerLinkActive="active-route"
  >
    <i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
    <span class="layout-menuitem-text">{{ item.label }}</span>
    <i
      *ngIf="item.items"
      class="pi pi-fw pi-chevron-down layout-submenu-toggler"
    ></i>
  </a>

  <ul
    *ngIf="item.items"
    [@children]="
      isSlim
        ? root
          ? isMobile
            ? 'visible'
            : slimClick
            ? active
              ? 'slimVisibleAnimated'
              : 'slimHiddenAnimated'
            : active
            ? 'visible'
            : 'hidden'
          : active
          ? 'visible'
          : 'hidden'
        : root
        ? 'visible'
        : active
        ? 'visibleAnimated'
        : 'hiddenAnimated'
    "
    role="menu"
  >
    <!-- CHECKING CHILDREN-->
    <ng-template [ngForOf]="item.items" let-child let-i="index" ngFor>
      <ng-container *ngIf="checkPermissions(child); else noPermission">
        <li
          [class]="child?.badgeClass"
          [index]="i"
          [item]="child"
          [parentKey]="key"
          [root]="false"
          boma-portal-menu-item
        ></li>
      </ng-container>

      <ng-template #noPermission>
        <li class="p-2"><i class="pi pi-lock mr-2"></i>{{ child.label }}</li>
      </ng-template>
    </ng-template>
  </ul>
</ng-container>
